export function reorderArray(input, from, to) {
    const clonedArray = [...input];
    const element = clonedArray[from];
    clonedArray.splice(from,1);
    clonedArray.splice(to, 0, element);
    return clonedArray;
}
